export default __webpack_public_path__ + "static/media/i4.6b8b0341.jpg";